import { useMutation } from "@apollo/client/react";

import {
  IntakeInterviewLinkDocument,
  IntakeInterviewReviewDocument,
  Status,
} from "@app_schema";

import { track } from "@application/utilities/track";

// Make the claimant's link (or a new one), and mark the outline reviewed.
export const useIntakeInterviewActions = (projectId: string) => {
  const [link, { loading: linking }] = useMutation(
    IntakeInterviewLinkDocument,
    {
      variables: { id: projectId },
      refetchQueries: ["DashboardProjectsIntakeInterview"],
    },
  );
  const [review, { loading: reviewing, error: reviewError }] = useMutation(
    IntakeInterviewReviewDocument,
    { variables: { id: projectId } },
  );

  return {
    makeLink: () =>
      link().then((result) => {
        if (result.data?.project.intakeInterviewLink.status === Status.Ok) {
          track("intake_link_created", { project_id: projectId });
        }
        return result;
      }),
    linking,
    // A failed review shows under the button, so it can be tried again.
    markReviewed: () =>
      review()
        .then(({ data }) => {
          if (data?.project.intakeInterviewReview.status === Status.Ok) {
            track("intake_reviewed", { project_id: projectId });
          }
        })
        .catch(() => undefined),
    reviewing,
    reviewFailed: !!reviewError,
  } as const;
};
